module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.type === 'btn') { 
    ; __append(" <button class=\"btn btn-sm btn-clear remove-field\" type=\"button\">")
    ; __append(escapeFn( locals.text ))
    ; __append("</button> ")
    ;  } else if (locals.type === 'link') { 
    ; __append(" <a href=\"\" class=\"text-muted small remove-field\">")
    ; __append(escapeFn( locals.text ))
    ; __append("</a> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/brand/remove_property/template.ejs
// module id = 1298
// module chunks = 1